import { Directive, ElementRef} from '@angular/core';
/*
uso : 

<input type="password" appPassword class="form-control" id="password" name="password" formControlName="password">

esto tambien funciona 

<input [type]="isPasswordVisible ? 'text' : 'password'" ... />
<i [class]="isPasswordVisible ? 'eye-close' : 'eye-open'" (click)="isPasswordVisible = !isPasswordVisible"></i>

*/
@Directive({
  selector: '[appPassword]'
})
export class AppPasswordDirective {
  private _shown = false;
  constructor(private el: ElementRef) {
    this.setUp();
  }

  toggle(span: HTMLElement) {
    this._shown = !this._shown;
    if (this._shown) {
      this.el.nativeElement.setAttribute('type', 'text');
      span.innerHTML = '<div style="background-color: #f1f2f4;border: 1px solid #ced4da; border-radius: 6px;" class="p-1"><i class="fa fa-eye-slash" style="color:#ced4da"></i></div>';
    } else {
      this.el.nativeElement.setAttribute('type', 'password');
      span.innerHTML = '<div style="background-color: #f1f2f4;border: 1px solid #ced4da; border-radius: 6px;" class="p-1"><i class="fa fa-eye"></i></div>';
    }
  }

  setUp() {
    const parent = this.el.nativeElement.parentNode;
    const span = document.createElement('span');
    span.innerHTML = '<div style="background-color: #f1f2f4;border: 1px solid #ced4da; border-radius: 6px;" class="p-1"><i class="fa fa-eye"></i></div>';
    span.addEventListener('click', (event) => {
      this.toggle(span);
    });
    parent.appendChild(span);
  }

}
